import { ALL } from "../constants/strings";

export const transformAccount = account =>
  String(account).toLowerCase() === ALL ? "" : account;
